import { WidgetT } from 'business/definitions';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'store/hooks';

const useScrollToWidgetFromHash = (widgets: WidgetT[]): number => {
    const { t } = useTranslation();
    const { hash } = useLocation();
    const dispatch = useDispatch();
    const scrolledRef = useRef('');
    const hasAlreadyScrolled = scrolledRef.current === hash;
    const [initialPosition, setInitialPosition] = useState<number>(0);
    if (hasAlreadyScrolled || widgets.length === 0) {
        return initialPosition;
    }
    const widgetId = hash.slice(1);
    const element = document.getElementById(widgetId);
    if (element) {
        element.scrollIntoView({ block: 'center' });
        scrolledRef.current = hash;
    }
    const widget = widgets.find((w) => `widget-${w.key}` === widgetId);
    if (!widget) {
        if (hash.startsWith('#widget-')) {
            dispatch.vision.notifyUser({
                message: t('widget.widgetNotFound'),
                snackType: 'warning',
            });
        }
        return initialPosition;
    }
    const yPosition = widget.position.md.y;
    const shouldSetPosition = yPosition !== initialPosition;
    if (shouldSetPosition) {
        setInitialPosition(yPosition ?? 0);
    }
    return initialPosition;
};

export default useScrollToWidgetFromHash;
